module.exports = __webpack_public_path__ + "img/vigia.868b7216.jpg";